/* ============================================================
   Brndpwr — gedrag voor de nieuwe blokken (v2)
   ============================================================ */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function inView(el, m) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top < h - (m || 0) && r.bottom > (m || 0);
  }

  /* ---- 2. feature-spotlight: accordion + wisselend beeld ---- */
  function initSpotlight() {
    document.querySelectorAll('[data-spotlight]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.sp-item'));
      var shots = Array.prototype.slice.call(root.querySelectorAll('.sp-shot'));
      if (!items.length) return;
      function activate(i) {
        items.forEach(function (it, k) { it.classList.toggle('on', k === i); });
        shots.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      }
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { activate(i); });
        it.addEventListener('mouseenter', function () { if (!reduced) activate(i); });
      });
      activate(0);
    });
  }

  /* ---- 3. dynamisch blok: auto-play met progressbalken ---- */
  function initDyncar() {
    document.querySelectorAll('[data-dyncar]').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.dc-item'));
      var shots = Array.prototype.slice.call(root.querySelectorAll('.dc-shot'));
      if (!items.length) return;
      var cur = -1, timer = null, started = false;
      function show(i) {
        cur = i;
        items.forEach(function (it, k) {
          it.classList.toggle('on', k === i);
          var fill = it.querySelector('.dc-fill');
          if (!fill) return;
          if (k === i) {
            var dur = parseInt(it.getAttribute('data-dur') || '6000', 10);
            fill.style.transition = 'none'; fill.style.width = '0%';
            // force reflow then animate
            void fill.offsetWidth;
            fill.style.transition = 'width ' + dur + 'ms linear';
            fill.style.width = '100%';
          } else {
            fill.style.transition = 'none'; fill.style.width = '0%';
          }
        });
        shots.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      }
      function next() { show((cur + 1) % items.length); schedule(); }
      function schedule() {
        if (timer) clearTimeout(timer);
        if (reduced) return;
        var dur = parseInt(items[cur].getAttribute('data-dur') || '6000', 10);
        timer = setTimeout(next, dur);
      }
      items.forEach(function (it, i) {
        it.addEventListener('click', function () { show(i); schedule(); });
      });
      // pauzeer auto-play tijdens hover zodat lezen niet onderbroken wordt
      root.addEventListener('mouseenter', function () { if (timer) { clearTimeout(timer); timer = null; } });
      root.addEventListener('mouseleave', function () { if (started) schedule(); });
      function begin() {
        if (started) return;
        if (!inView(root, 120)) return;
        started = true; show(0); schedule();
      }
      begin();
      if (!started) window.addEventListener('scroll', begin, { passive: true });
    });
  }

  /* ---- 4. sticky scrollytelling ---- */
  function initScrolly() {
    document.querySelectorAll('[data-scrolly]').forEach(function (root) {
      var steps = Array.prototype.slice.call(root.querySelectorAll('.scrolly-step'));
      var frames = Array.prototype.slice.call(root.querySelectorAll('.scrolly-frame'));
      var bar = root.querySelector('.scrolly-progress i');
      if (!steps.length) return;
      var n = steps.length, active = -1;
      function set(i, p) {
        if (i !== active) {
          active = i;
          steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
          frames.forEach(function (f, k) { f.classList.toggle('on', k === i); });
        }
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      }
      function upd() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var total = root.offsetHeight - vh;
        var scrolled = Math.min(Math.max(-r.top, 0), total);
        var p = total > 0 ? scrolled / total : 0;
        var idx = Math.min(n - 1, Math.floor(p * n + 0.0001));
        if (p >= 1) idx = n - 1;
        set(idx, p);
      }
      upd();
      window.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
    });
  }

  /* ---- 5. review-rail: navigatie + case-modal ---- */
  function initRevrail() {
    document.querySelectorAll('[data-revrail]').forEach(function (root) {
      var rail = root.querySelector('.revrail');
      var prev = root.querySelector('[data-rev-prev]');
      var next = root.querySelector('[data-rev-next]');
      if (rail && (prev || next)) {
        var step = function () {
          var card = rail.querySelector('.rev-card');
          return card ? card.getBoundingClientRect().width + 18 : 300;
        };
        var atEnd = function () { return rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4; };
        var atStart = function () { return rail.scrollLeft <= 4; };
        if (prev) prev.addEventListener('click', function () {
          if (atStart()) rail.scrollTo({ left: rail.scrollWidth, behavior: 'smooth' });
          else rail.scrollBy({ left: -step() * 1.4, behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          if (atEnd()) rail.scrollTo({ left: 0, behavior: 'smooth' });
          else rail.scrollBy({ left: step() * 1.4, behavior: 'smooth' });
        });
      }
    });
    // modal
    var modal = document.querySelector('[data-case-modal]');
    if (!modal) return;
    var box = modal.querySelector('.cm-box');
    var lastFocus = null;
    function fill(d) {
      modal.querySelector('[data-cm-photo]').src = d.photo || '';
      modal.querySelector('[data-cm-logo]').textContent = d.logo || '';
      modal.querySelector('[data-cm-title]').textContent = d.title || '';
      modal.querySelector('[data-cm-quote]').textContent = d.quote || '';
      var intro = modal.querySelector('[data-cm-intro]');
      if (intro) { intro.textContent = d.intro || ''; intro.style.display = d.intro ? '' : 'none'; }
      modal.querySelector('[data-cm-name]').textContent = d.name || '';
      modal.querySelector('[data-cm-role]').textContent = d.role || '';
      var meta = modal.querySelector('[data-cm-meta]');
      meta.innerHTML = '';
      (d.stats || []).forEach(function (s) {
        var el = document.createElement('div'); el.className = 'm';
        el.innerHTML = '<div class="v grad-text">' + s.v + '</div><div class="l">' + s.l + '</div>';
        meta.appendChild(el);
      });
    }
    function open(d) {
      lastFocus = document.activeElement;
      fill(d); modal.classList.add('open'); document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('open'); document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.querySelectorAll('.rev-card[data-case]').forEach(function (card) {
      card.addEventListener('click', function () {
        try { open(JSON.parse(card.getAttribute('data-case'))); } catch (e) {}
      });
    });
    modal.querySelectorAll('[data-cm-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('open')) close(); });
    window.__brndOpenCase = open;
  }

  /* ---- 6. team contact-bar: schuivende highlight ---- */
  function initContactBar() {
    document.querySelectorAll('.contact-bar').forEach(function (bar) {
      var hl = bar.querySelector('.cb-hl');
      var links = Array.prototype.slice.call(bar.querySelectorAll('a'));
      if (!hl || !links.length) return;
      function place(el) {
        links.forEach(function (l) { l.classList.toggle('on', l === el); });
        hl.style.width = el.offsetWidth + 'px';
        hl.style.transform = 'translateX(' + (el.offsetLeft - links[0].offsetLeft) + 'px)';
      }
      links.forEach(function (l) {
        l.addEventListener('mouseenter', function () { if (!reduced) place(l); });
      });
      var init = bar.querySelector('a.on') || links[0];
      requestAnimationFrame(function () { place(init); });
      window.addEventListener('resize', function () { place(bar.querySelector('a.on') || links[0]); });
    });
  }

  /* ---- 7. clean video: klik laadt embed ---- */
  function initVideo() {
    document.querySelectorAll('[data-video]').forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-video');
        if (!id || card.dataset.loaded) return;
        card.dataset.loaded = '1';
        var ifr = document.createElement('iframe');
        ifr.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        ifr.allow = 'autoplay; encrypted-media; fullscreen';
        ifr.setAttribute('allowfullscreen', '');
        card.innerHTML = ''; card.appendChild(ifr); card.style.cursor = 'default';
      });
    });
  }

  /* ---- 9. geanimeerde marker: highlight bij in-beeld ---- */
  function initMark() {
    var marks = Array.prototype.slice.call(document.querySelectorAll('.mark.hl'));
    if (reduced) { marks.forEach(function (m) { m.classList.add('on'); }); return; }
    function check() {
      marks = marks.filter(function (m) {
        if (inView(m, 40)) { m.classList.add('on'); return false; }
        return true;
      });
    }
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('load', check);
  }

  function boot() {
    initSpotlight(); initDyncar(); initScrolly(); initRevrail(); initContactBar(); initVideo(); initMark();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
